<template>
  <v-tooltip
    class="qx-tooltip"
    :activator="target"
    :location="location"
    :open-on-hover="hoverOpens">
    <template
      v-if="!target"
      #activator="{ props }">
      <slot
        name="content"
        :props="props" />
    </template>
    <p
      v-if="text"
      class="my-0"
      v-html="$sanitize(text)" />
    <slot v-else />
  </v-tooltip>
</template>

<script setup>
import { defineProps } from 'vue';
defineProps({
  target: {
    type: String,
    default: null,
  },
  text: {
    type: String,
    default: undefined,
  },
  location: {
    type: String,
    default: 'top center',
    validator: (value) =>
      ['top start', 'start center', 'end center', 'top center', 'top', 'bottom center'].includes(value),
  },
  origin: {
    type: String,
    default: 'auto',
    validator: (value) => ['top center', 'end center', 'end top', 'bottom center', 'auto'].includes(value),
  },
  hoverOpens: {
    type: Boolean,
    default: true,
  },
});
defineEmits(['update:isVisible']);
</script>

<style lang="scss">
.qx-tooltip {
  .v-overlay__content {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;
    padding: 0.25rem 0.5rem;
    background: $gray-200;
    font-size: 13px;
    color: $black;
    width: auto;
    line-height: 1.5;
    max-width: 200px !important;
    overflow-wrap: anywhere;
  }
}
</style>
